module.exports = __webpack_public_path__ + "img/ic_24_team_volleyball.64ba7e1c.svg";